import { PreBakedAnimation } from '@Animation/mechanics/base/transition-animation'
import { tweenPromise } from '@Animation/utils'
import { PLUS_3_STANDARD_ATLAS_FRAMES, PLUS_3_TEXTURE_KEYS } from './constants'

export class Plus3TransitionEffect extends PreBakedAnimation {
  logo: Phaser.GameObjects.Image
  glow: Phaser.GameObjects.Image

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)

    this.logo = scene.add.image(
      0,
      0,
      PLUS_3_TEXTURE_KEYS.STANDARD_ATLAS,
      PLUS_3_STANDARD_ATLAS_FRAMES.LOGO,
    )
    this.glow = scene.add.image(
      0,
      0,
      PLUS_3_TEXTURE_KEYS.STANDARD_ATLAS,
      PLUS_3_STANDARD_ATLAS_FRAMES.GLOW,
    )

    this.logo.setOrigin(0.5, 0.5)
    this.glow.setOrigin(0.5, 0.5)

    this.scale = 0.05

    this.add(this.glow)
    this.add(this.logo)
  }

  async playEffect(): Promise<void> {
    await tweenPromise(this.scene, {
      targets: this,
      scale: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
    })()

    await tweenPromise(this.scene, {
      targets: this.glow,
      rotation: Phaser.Math.PI2 / 4,
      duration: 1500,
    })()

    await tweenPromise(this.scene, {
      targets: this,
      scale: 0,
      duration: 500,
      ease: Phaser.Math.Easing.Back.In,
    })()

    this.destroy()
  }

  stop() {
    this.scene.tweens.getTweensOf([this, this.glow]).forEach((tween) => {
      if (tween.isActive() || tween.isPlaying()) {
        tween.stop()
      }
    })
  }
}
